import { X } from "lucide-react";
import { useTabContext } from "@/contexts/TabContext";
import { cn } from "@/lib/utils";

export function TabBar() {
  const { tabs, activeTabId, switchTab, closeTab } = useTabContext();

  if (tabs.length === 0) return null;

  return (
    <div className="flex items-center border-b bg-card overflow-x-auto scrollbar-none">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        const Icon = tab.icon;
        return (
          <div
            key={tab.id}
            className={cn(
              "group flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-r cursor-pointer whitespace-nowrap select-none",
              "hover:bg-accent/50 transition-colors",
              isActive
                ? "bg-background text-foreground border-b-2 border-b-primary"
                : "text-muted-foreground bg-muted/30",
            )}
            onClick={() => switchTab(tab.id)}
          >
            {Icon && <Icon className="h-3.5 w-3.5 shrink-0" />}
            <span className="max-w-[160px] truncate">{tab.label}</span>
            {tab.closable && (
              <button
                className={cn(
                  "ml-1 rounded-full p-0.5 transition-colors shrink-0",
                  "opacity-0 group-hover:opacity-100",
                  isActive && "opacity-100",
                  "hover:bg-destructive/20 hover:text-destructive",
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  closeTab(tab.id);
                }}
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
